export default __webpack_public_path__ + "static/icon-11-3-71ad9936f81c390a72a39c92bab32173.png";